import Container from 'react-bootstrap/Container';
import DecisionsPage from "../components/decisions/DecisionsPage";

export default function DecisionsRoute() {
    return (
        <>
            <Container>
                <DecisionsPage />
            </Container>
        </>
    );
}
